export default __webpack_public_path__ + "static/media/building-transparent@0.5x.8c305e91.png";